export default {
    showCode (state) {
        state.showCode = true;
    },
    hideCode (state) {
        state.showCode = false;
    }
};